import React from 'react'

//API
import useUser from '@/features/users/useUser'

//Helper
import EditableTable from '@/components/Table/EditableTable'
import getCostCenterUserTableColumns from '../../constants/costCenterUserTableColumns'

const CostCenterUserTable = ({ data, handleUpdateData, removeUser }) => {
  const { useUserOptions } = useUser()
  const { data: userOptions } = useUserOptions({ valueKey: '_id', withNilOption: true })

  const columnDef = getCostCenterUserTableColumns({ removeUser, userOptions })
  return (
    <EditableTable
      columnDef={columnDef}
      data={data}
      isReadOnly
      canEdit={false}
      footer={false}
      isStriped={false}
      updateData={handleUpdateData}
      tableWidth="100%"
    />
  )
}

export default CostCenterUserTable
